import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { arrowDown, arrowUp } from 'styles/icons';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const Wrapper = styled.nav<{ theme: Theme; $headerHeight: number }>`
  z-index: 9;
  width: 100%;
  position: sticky;
  top: ${({ $headerHeight }) => $headerHeight}px;
  left: 0;
  grid-column: 1 / -1;
  grid-row-start: 3;

  @media (${breakpoint.lgMin}) {
    top: ${({ $headerHeight }) => $headerHeight + 8}px;
  }
`;

export const Title = styled.div<{ theme: Theme; $dropdownOpened: boolean }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
  background-color: ${getColor('surfaceWhite')};
  color: ${getColor('textPrimary')};
  box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}0D;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  cursor: pointer;
  width: 100%;

  &:after {
    align-self: center;
    content: '';
    ${arrowDown};
    width: 12px;
    height: 12px;
    margin-top: 0px;
  }

  ${({ $dropdownOpened }) =>
    $dropdownOpened &&
    css<{ theme: Theme }>`
            background-color: ${getColor('surfaceBrand')};
            color: ${getColor('textWhite')};
            box-shadow: none;
            &:after {
                ${arrowUp};
                width: 12px;
                height: 12px;
                align-self: center;
                margin-bottom: -8px;
            }
    `}
`;

export const ContentWrapper = styled.div<{ theme: Theme; $dropdownOpened: boolean }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'medium')};
  padding-top: 8px;
  max-height: 460px;
  overflow-y: auto;
  box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}0D;
  display: ${({ $dropdownOpened }) => ($dropdownOpened ? 'block' : 'none')};
  background-color: ${getColor('surfaceWhite')};
`;

export const Item = styled.div<{ theme: Theme }>`
  font-size: 16px;
  font-weight: 500;
  padding: 8px 24px;

  &:hover {
    background-color: ${getColor('shadeBrandPrimary100')};
  }
`;
